import PropTypes from 'prop-types';
import BackLink from '../backLink';
import AuthFormLayout from '../authFormLayout';
import { ReactComponent as TonalityIcon } from '../../../assets/icons/tonality.svg';
import AUTHENTICATION_FIELDS from './fields';

const DisableAuthenticationFormLayout = props => {
  const { translations, navigate } = props;

  return (
    <AuthFormLayout
      {...props}
      subtitleVariant="body1"
      icon={TonalityIcon}
      fields={AUTHENTICATION_FIELDS}
      isDisableAuthenticationView
    >
      <BackLink
        title={translations.backLabel}
        navigate={navigate}
        to="/2fa/options"
      />
    </AuthFormLayout>
  );
};

DisableAuthenticationFormLayout.propTypes = {
  translations: PropTypes.object.isRequired,
};

export default DisableAuthenticationFormLayout;
